import axios, {AxiosError, AxiosResponse} from 'axios';
import {ErrorObject, Tag} from 'types';

/**
 * Get all tags.
 * @return {Promise<string[] | ErrorObject | undefined>}
 */
export default async function getTags<T extends object>() {
  return axios({
    method: 'GET',
    url: `${process.env.REACT_APP_API_BASE_URL}/programs/tags`,
  }).then((response: AxiosResponse<Tag[]>) => (
    response.data
  )).catch((error: AxiosError<ErrorObject>) => (
    error.response?.data
  ));
}
